// document.addEventListener("DOMContentLoaded", function () {
//   function toggleFooterDropdown() {
//     const headings = document.querySelectorAll("footer .footer-block__heading");

//     if (window.innerWidth < 749) {
//       headings.forEach((heading) => {
//         // Ensure event listener is not added multiple times
//         heading.removeEventListener("click", handleClick);
//         heading.addEventListener("click", handleClick);
//       });
//     } else {
//       // Ensure all dropdowns are open on larger screens
//       document.querySelectorAll("footer .footer-block__details-content").forEach((content) => {
//         content.style.display = "block";
//       });

//       // Remove event listeners properly
//       headings.forEach((heading) => {
//         heading.removeEventListener("click", handleClick);
//       });
//     }
//   }

//   function handleClick() {
//     const content = this.nextElementSibling;
//     if (content) {
//       content.style.display = content.style.display === "block" ? "none" : "block";
//     }
//     this.classList.toggle("active"); // Optional: Add a class for styling
//   }

//   toggleFooterDropdown(); // Initial check
//   window.addEventListener("resize", toggleFooterDropdown); // Reapply on resize
// });


document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll("footer .footer-block__heading");

  function setupDropdowns() {
    if (window.innerWidth < 749) {
      headings.forEach((heading) => {
        const content = heading.nextElementSibling;

        // Set initial styles
        if (content && !content.style.maxHeight) {
          content.style.overflow = "hidden";
          content.style.transition = "max-height 0.3s ease";
          content.style.maxHeight = "0px";
        }

        heading.removeEventListener("click", toggleDropdown);
        heading.addEventListener("click", toggleDropdown);
      });
    } else {
      headings.forEach((heading) => {
        const content = heading.nextElementSibling;
        if (content) {
          content.style.maxHeight = "none";
        }
        heading.removeEventListener("click", toggleDropdown);
      });
    }
  }

  function toggleDropdown() {
    const content = this.nextElementSibling;
    if (!content) return;

    const isOpen = content.style.maxHeight !== "0px" && content.style.maxHeight !== "";

    if (isOpen) {
      content.style.maxHeight = "0px";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }

    this.classList.toggle("active");
  }

  setupDropdowns();
  window.addEventListener("resize", setupDropdowns);
});
